import { StatusBadge, type KitStatus } from './Badge';

export const CLAIM_STATUS_KIT: Record<string, { status: KitStatus; label: string }> = {
  DRAFT: { status: 'neutral', label: 'Draft' },
  SUBMITTED: { status: 'info', label: 'Submitted' },
  ADMIN_APPROVED: { status: 'info', label: 'Admin Approved' },
  RETURNED_TO_ADMIN: { status: 'warn', label: 'Returned' },
  FINANCE_APPROVED: { status: 'info', label: 'Finance Approved' },
  APPROVED: { status: 'ok', label: 'Approved' },
  REJECTED: { status: 'danger', label: 'Rejected' },
};

export function ClaimStatusBadge({
  status,
  label,
}: {
  status: string;
  label?: string;
}) {
  const mapped = CLAIM_STATUS_KIT[status] ?? { status: 'neutral' as const, label: status };
  return (
    <StatusBadge status={mapped.status} pulse={status === 'SUBMITTED' || status === 'RETURNED_TO_ADMIN'}>
      {label ?? mapped.label}
    </StatusBadge>
  );
}
